import { ModelContent, ModalHeader, ModalFooter } from "./styled";
import { ReactComponent as Cross } from "assets/svg/closeBox.svg";
import { ReactComponent as Info } from "assets/svg/info.svg";
import { Modal } from "antd";

import { LoadingOutlined } from "@ant-design/icons";

const DeleteModal = ({
  openDeleteModal,
  onCloseDeleteModal,
  isLoading,
  onDelete,
  title,
  description,
}: any) => {
  return (
    <Modal
      footer={null}
      closable={false}
      onCancel={onCloseDeleteModal}
      title={false}
      open={openDeleteModal}
      centered
      width={460}
      className="metricModel"
    >
      <ModalHeader>
        <div className="modal-left">
          <div className="modal-left-info">
            <Info />
          </div>
          <h3>{title}</h3>
        </div>
        <Cross className={"c-pointer"} onClick={onCloseDeleteModal} />
      </ModalHeader>

      <ModelContent>{description}</ModelContent>

      <ModalFooter>
        <button onClick={onCloseDeleteModal} disabled={isLoading}>
          Cancel
        </button>
        <button onClick={onDelete} disabled={isLoading}>
          {isLoading ? <LoadingOutlined /> : "Delete"}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
